var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErase32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.102 16.113L15.749 3.388a1.453 1.453 0 0 0-.975-.376 1.275 1.275 0 0 0-.425.067l-14.197 4-.05 1.429c-.067 1.858 1.175 4.718 1.771 6.304a1.33 1.33 0 0 0 .308.486l13.944 14.215a1.42 1.42 0 0 0 1.012.424 1.44 1.44 0 0 0 .538-.105l13.433-5.452c1.877-.752.345-4.776-.568-7.136zM14.62 4.041l.153-.03a.458.458 0 0 1 .304.118l13.423 11.9-11.182 4.193a2.885 2.885 0 0 1-3.049-.661L2.239 7.53zm16.116 19.41L17.3 28.905a.425.425 0 0 1-.162.033.419.419 0 0 1-.3-.126L2.895 14.597a.352.352 0 0 1-.081-.125l-.293-.763c-.585-1.504-1.47-3.776-1.42-5.166l.025-.7 12.436 12.424a3.882 3.882 0 0 0 4.107.89l11.626-4.36.312.806c1.836 4.746 1.497 5.7 1.13 5.847z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErase32);
export default __webpack_public_path__ + "static/media/erase-32.12dc278433b6e9fabafa025f7587b3fa.svg";
export { ForwardRef as ReactComponent };